import React from "react";

export const FloatingChatBubble = ({ iconUrl, bubbleColor, onClick, isChatOpen, compact,isWhitelabelled }) => (
  <div
    style={{
      position: "relative",
      cursor: "pointer",
      animation: !isChatOpen ? "float 2s ease-in-out 3" : "none",
    }}
    onClick={onClick}
  >
    <div
      style={{
        position: "relative",
        width: compact ? "72px" : "110px",
        height: compact ? "46px" : "70px",
        boxSizing: "border-box",
        backgroundColor: bubbleColor,
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: compact ? "8px" : "12px",
        textAlign: "center",
        boxShadow: "0 8px 32px rgba(31,72,75,0.3)",
        transition: "transform 0.3s cubic-bezier(0.4,0,0.2,1)",
        border: "2px solid rgba(255,255,255,0.1)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05) translateY(-4px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <img
        src={iconUrl}
        alt="Ansera Logo"
        style={{
          width: compact ? "22px" : "32px",
          height: compact ? "22px" : "32px",
          objectFit: "contain",
          marginBottom: "3px",
          filter: isWhitelabelled?"":"brightness(0) invert(1)",
        }}
      />
      <p
        style={{
          fontSize: compact ? "9px" : "12px",
          color: "white",
          margin: 0,
          fontWeight: 700,
          letterSpacing: "0.5px",
          marginTop: "-5px",
        }}
      >
        Ask me
      </p>
    </div>
    <style>{`
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-18px); }
      }
    `}</style>
  </div>
);